import React, { forwardRef, useMemo } from "react";
import Button, { ButtonProps } from "atoms/buttons/button";
import Icon from "atoms/icons/icon";
import { Icons } from "atoms/constants/icons";
import { useLocalization } from "utilities/hooks/use-localization";
import PageRecord from "models/view-models/page-record";
import usePageActionPermission, {
    PageAction,
} from "pages/notebooks/use-page-action-permission";
import DeprecatedShow from "atoms/wrappers/show";

export interface SharePageMenuItemProps extends ButtonProps {
    onClick: () => void;
    page: PageRecord;
}
const CSS_CLASS_NAME = "c-page-context-menu";

const SharePageMenuItem = forwardRef<HTMLButtonElement, SharePageMenuItemProps>(
    ({ page, onClick }, _) => {
        const { t } = useLocalization();
        const { can } = usePageActionPermission(page);
        const canShare = useMemo(() => can(PageAction.Share), [can]);

        return (
            <DeprecatedShow when={canShare}>
                <Button
                    accessibleText={t("shareItem", {
                        item: t("page"),
                    })}
                    cssClassName={`${CSS_CLASS_NAME}__button`}
                    onClick={onClick}>
                    <Icon type={Icons.Share} />
                    {t("sharePage")}
                </Button>
            </DeprecatedShow>
        );
    }
);

export default SharePageMenuItem;
